import React from "react";
import { useLocation } from "react-router-dom";
import ReactPlayer from "react-player";

const InfoPs = (state) => {
  let location = useLocation();

  const { psychologist } = location.state;
  const {
    name = "",
    lastname = "",
    photoURL = "",
    attentionAreas = [],
    therapeuticWorkModel = [],
    academicTraining = [],
    country = "",
    aboutMe = "",
    video = "",
  } = psychologist.data;

  return (
    <div>
      <div style={{ flex: 1, marginHorizontal: 20 }}>
        <div
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: 50,
            marginBottom: 30,
          }}
        >
          <img
            alt="imagen perfil"
            style={{
              width: 150,
              height: 150,
              borderRadius: 50,
              marginRight: 25,
            }}
            src={
              photoURL
                ? photoURL
                : "https://firebasestorage.googleapis.com/v0/b/kameliadev-a0de5.appspot.com/o/photoURL%2FDefault%2Fprofile_icon.png?alt=media&token=df0e7294-8dee-40cd-ab9e-4fd18c723df7"
            }
          />

          <div>
            <div
              style={{
                fontSize: 17,
                fontWeight: "bold",
                color: "var(--primary)",
              }}
            >
              {name}{" "}
            </div>
            <div
              style={{
                fontSize: 17,
                fontWeight: "bold",
                color: "var(--primary)",
              }}
            >
              {lastname}
            </div>

            <div style={{ fontSize: 12, color: "var(--primary)" }}>
              {country}
            </div>
          </div>
        </div>
        {video.length > 0 ? (
          <ReactPlayer url={video} controls width="240px" height="426px" />
        ) : (
          <div></div>
        )}
        <div style={{ marginBottom: 30 }}>
          <div
            style={{
              marginBottom: 10,
              fontSize: 17,
              fontWeight: "bold",
              color: "var(--primary)",
            }}
          >
            Sobre mí:
          </div>
          <div
            style={{
              padding: 10,
              color: "var(--primary)",
              borderWidth: 1,
              borderColor: "var(--secondary)",
              borderRadius: 10,
              fontSize: 15,
            }}
          >
            {aboutMe}
          </div>
        </div>

        <div style={{ marginBottom: 30 }}>
          <div
            style={{
              marginBottom: 10,
              fontSize: 17,
              fontWeight: "bold",
              color: "var(--primary",
            }}
          >
            Áreas de atención:
          </div>
          <div
            style={{
              padding: 10,
              flexWrap: "wrap",
              flexDirection: "row",
              marginBottom: 6,
              borderWidth: 1,
              borderColor: "var(--secondary)",
              borderRadius: 10,
            }}
          >
            {(attentionAreas || []).map((area) => (
              <div key={Math.random()}>{area}</div>
            ))}
          </div>
        </div>
        <div style={{ marginBottom: 30 }}>
          <div
            style={{
              marginBottom: 10,
              fontSize: 17,
              fontWeight: "bold",
              color: "var(--primary)",
            }}
          >
            Modelo de trabajo terapéutico:
          </div>
          <div
            style={{
              padding: 10,
              flexWrap: "wrap",
              flexDirection: "row",
              marginTop: 10,
              marginBottom: 6,
              borderWidth: 1,
              borderColor: "var(--)",
              borderRadius: 10,
            }}
          >
            {(therapeuticWorkModel || []).map((model) => (
              <div
                style={{
                  width: 170,
                  height: 30,
                  marginTop: 10,
                  marginVertical: 5,
                  marginHorizontal: "2%",
                  paddingTop: 3,
                  paddingLeft: 8,
                  borderRadius: 8,
                  overflow: "hidden",
                  color: "white",
                  fontSize: 15,
                  backgroundColor: "grey",
                }}
                adjustsFontSizeToFit={true}
                numberOfLines={1}
                key={Math.random()}
              >
                {model}
              </div>
            ))}
          </div>
        </div>
        <div style={{ marginBottom: 30 }}>
          <div
            style={{
              marginBottom: 10,
              fontSize: 17,
              fontWeight: "bold",
              color: "var(--primary)",
            }}
          >
            Formación académica:
          </div>
          <div
            style={{
              padding: 10,
              marginBottom: 6,
              borderWidth: 1,
              borderColor: "var(--secondary)",
              borderRadius: 10,
            }}
          >
            {(academicTraining || []).map((training) => (
              <div
                key={Math.random()}
                style={{ marginVertical: 10, flexDirection: "row" }}
              >
                <div
                  style={{
                    width: "80%",
                    color: "var(--primary)",
                    fontSize: 15,
                  }}
                >
                  {training}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPs;
